import React from "react";
import { LiaCheckDoubleSolid } from "react-icons/lia";

const CopyToast = ({ copiedId }) => {
  if (!copiedId) return null;

  return (
    <>
      <div
        style={{
          position: "fixed",
          // bottom: "30px",
          top: "20px",
          left: "50%",
          transform: "translateX(-50%)",
          backgroundColor: "#28a745",
          color: "white",
          padding: "12px 20px",
          borderRadius: "8px",
          fontSize: "14px",
          fontWeight: "500",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          zIndex: 9999,
          boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
          animation: "slideUp 0.3s ease-out",
        }}
      >
        <LiaCheckDoubleSolid style={{ fontSize: "16px" }} />
        Copied
      </div>

      <style>
        {`
          @keyframes slideUp {
            from {
              opacity: 0;
              transform: translateX(-50%) translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateX(-50%) translateY(0);
            }
          }
        `}
      </style>
    </>
  );
};

export default CopyToast;